import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^https:\/\/annual-plan\.zyght\.com\/api\//,
    /^https:\/\/annual-plan\.zyght\.com\/external\/annual-plans\/export/,
    /^\/api\//,
    /^\/external\/annual-plans\/export/,
  ],
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});
